import { isDebugFlagEnabled } from '../../../utils/debugTools';

export const NATURAL_CAPTURE_INPUT_TYPES = {
  SIMPLE_LOCAL: 'simple_local',
  SMALL_STRUCTURED_REVIEW: 'small_structured_review',
  LONG_NOTE_REVIEW: 'long_note_review',
  IMPORT_EXISTING: 'import_existing',
  AI_FALLBACK: 'ai_fallback',
};

const normalizePreviewText = (text = '', maxLength = 180) => {
  const normalized = String(text || '').replace(/\s+/g, ' ').trim();
  if (!normalized) {
    return '';
  }

  return normalized.length > maxLength ? `${normalized.slice(0, maxLength - 1)}…` : normalized;
};

export const detectNaturalCaptureInputType = ({
  source = 'quick_log',
  route = '',
  isLongNote = false,
  hasStructuredEvents = false,
  hasStrongSimpleSignal = false,
  isImported = false,
} = {}) => {
  if (isImported || source === 'import') {
    return NATURAL_CAPTURE_INPUT_TYPES.IMPORT_EXISTING;
  }

  if (route === 'claude') {
    return NATURAL_CAPTURE_INPUT_TYPES.AI_FALLBACK;
  }

  if (isLongNote) {
    return NATURAL_CAPTURE_INPUT_TYPES.LONG_NOTE_REVIEW;
  }

  if (hasStructuredEvents) {
    return NATURAL_CAPTURE_INPUT_TYPES.SMALL_STRUCTURED_REVIEW;
  }

  if (hasStrongSimpleSignal || route === 'rule_only') {
    return NATURAL_CAPTURE_INPUT_TYPES.SIMPLE_LOCAL;
  }

  return NATURAL_CAPTURE_INPUT_TYPES.AI_FALLBACK;
};

export const buildNaturalCapturePipelineSnapshot = ({
  stage = '',
  inputType = '',
  text = '',
  rows = [],
  groupedRows = [],
  reviewRows = [],
  savedRows = [],
  metadata = {},
} = {}) => ({
  stage,
  inputType,
  textLength: String(text || '').length,
  preview: normalizePreviewText(text),
  rowCount: Array.isArray(rows) ? rows.length : 0,
  groupedRowCount: Array.isArray(groupedRows) ? groupedRows.length : 0,
  reviewRowCount: Array.isArray(reviewRows) ? reviewRows.length : 0,
  savedRowCount: Array.isArray(savedRows) ? savedRows.length : 0,
  metadata,
});

export const isNaturalCapturePipelineDebugEnabled = () => {
  return isDebugFlagEnabled([
    'debugImportParser',
    'debugQuickLogRouting',
    'debugNaturalCapturePipeline',
  ]);
};

export const traceNaturalCapturePipeline = (stage, payload = {}) => {
  if (!isNaturalCapturePipelineDebugEnabled()) {
    return;
  }

  // eslint-disable-next-line no-console
  console.warn(`[NaturalCapturePipeline] ${stage}`, payload);
};
